// Desired hook
import { useRef, useEffect } from 'react';

export const usePrevious = <T>(value: T): T | undefined => {
    const ref = useRef<T>();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
};

export const useCompare = <T>(val: T): boolean => {
    const prevVal = usePrevious(val);
    return prevVal !== val;
};
